import { APPLICATION_CONFIG } from "@constants/constants";
import { beginHandoff } from "@features/auth/auth";
import { createRouter } from "@tanstack/react-router";
import { describeBasePathMismatch } from "@utils/base-path/base-path";

import { routeTree } from "./routeTree.gen";
import { configSchema } from "./shared/schemas/config-schema";

if (typeof window !== "undefined") {
	try {
		configSchema.parse(APPLICATION_CONFIG);
	} catch (err) {
		console.error("Invalid application config", err);
		throw Error("Invalid application config");
	}

	// A base path set only at runtime is ignored, and the app then answers on a
	// path nothing is served from. Say so here rather than leaving a bare 404.
	const basePathMismatch = describeBasePathMismatch(
		APPLICATION_CONFIG.base_path,
		window._env_?.VITE_BASE_PATH,
	);
	if (basePathMismatch) console.error(basePathMismatch);

	// Before the router exists: it must never see the one-time code another
	// zypl app may have sent the user in with.
	beginHandoff();
}

export function getRouter() {
	return createRouter({
		routeTree,
		basepath: APPLICATION_CONFIG.base_path,
	});
}

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}
